import LayoutWithoutFooter from '../../../layouts/layoutWithoutFooter/LayoutWithoutFooter';
import './healthCheckLayout.css';

function HealthCheckLayout(props) {
  const { children } = props;
  return (
    <LayoutWithoutFooter>
      <section className="healthCheckLayout pageTopSpacing">{children}</section>
    </LayoutWithoutFooter>
  );
}

export default HealthCheckLayout;
